import { render } from "./foodMenuBox.vue?vue&type=template&id=ddaea8e4"
import script from "./foodMenuBox.vue?vue&type=script&lang=js"
export * from "./foodMenuBox.vue?vue&type=script&lang=js"

import "./foodMenuBox.vue?vue&type=style&index=0&id=ddaea8e4&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__